import { SEND_NOTIFICATION } from "@gql/notifications";
import { useNorthbeamMutation } from "@hooks/http";
import { type SendNotification } from "@north-beam/nb-client-side";
import { PrimaryButton } from "@shared/buttons";

export const Notifications = () => {
  const [sendNotification, { loading }] =
    useNorthbeamMutation<SendNotification>(SEND_NOTIFICATION, {
      useJobManager: true,
    });

  return (
    <div className="p-8">
      <h2>Notifications</h2>
      <div className="py-4">
        <PrimaryButton
          className="font-bold"
          loading={loading}
          onClick={() => sendNotification()}
        >
          TEST NOTIFICATIONS
        </PrimaryButton>
      </div>
    </div>
  );
};
